export default {"src":"/_next/static/media/logoSitter.2ec2a9f6.svg","height":35,"width":69,"blurWidth":0,"blurHeight":0};